import React from 'react';
import cn from 'classnames';

import {ITariff} from 'entities/tariff';

import {isFlagChip, TariffLimitChip} from './limitChips';

import styles from './TariffLimits.module.scss';

interface ITariffLimitsProps {
    item: ITariff,
    chips: TariffLimitChip[],
    className?: string,
}

const TariffLimits: React.FC<ITariffLimitsProps> = ({item, chips, className}) => {
    const visibleChips = chips.filter(chip => !isFlagChip(chip) || item[chip.key]);

    return (
        <div className={cn(styles.limits, className)}>
            {
                visibleChips.map(chip => isFlagChip(chip)
                    ? <span key={chip.key} className={cn(styles.limit, styles.limitOn)}>{chip.label}</span>
                    : <span key={chip.key} className={styles.limit}>
                        {`${chip.prefix ?? ''}${item[chip.key]}${chip.suffix ?? ''}`}
                    </span>,
                )
            }
        </div>
    );
};

export default React.memo(TariffLimits);
